import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CreateSecretInput30co61ns422r9 as CreateSecretInput } from '../CreateSecretInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretInput_InputAdapterClass;
function CreateSecretInput_InputAdapter() {
  if (CreateSecretInput_InputAdapterClass === VOID) {
    class $ {
      s3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      u6p(writer, customScalarAdapters, value) {
        writer.v47('partyId');
        get_partyIdAdapter().t3z(writer, customScalarAdapters, value.z6m_1);
        writer.v47('description');
        get_StringAdapter().t3z(writer, customScalarAdapters, value.a6n_1);
      }
      t3z(writer, customScalarAdapters, value) {
        return this.u6p(writer, customScalarAdapters, value instanceof CreateSecretInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'CreateSecretInput_InputAdapter', VOID, VOID, [Adapter()]);
    CreateSecretInput_InputAdapterClass = $;
  }
  return CreateSecretInput_InputAdapterClass;
}
var CreateSecretInput_InputAdapter_instance;
function CreateSecretInput_InputAdapter_getInstance() {
  return CreateSecretInput_InputAdapter_instance;
}
//region block: init
CreateSecretInput_InputAdapter_instance = new (CreateSecretInput_InputAdapter())();
//endregion
//region block: exports
export {
  CreateSecretInput_InputAdapter_instance as CreateSecretInput_InputAdapter_instanceo1n3bqwaqp7v,
};
//endregion

//# sourceMappingURL=CreateSecretInput_InputAdapter.mjs.map
